import "../pages.scss"
import { MedidasState } from '../../context/medidas/MedidasState';
import Datatable from "./medidasTable/Datatable"

const MedidasPage = () => {
  return (
    <>
      <MedidasState>
        <Datatable />
      </MedidasState>
    </>
  )
}

export default MedidasPage